<div id="chat" class="h-100">
  <div class="d-flex justify-content-between grap-1 h-100">
    <div class="chat-room px-1">
      <!--Search user-->
      <div class="search-user d-flex justify-content-between align-items-center mb-2">
        <input type="text" class="form-control" placeholder="{{ 'search_user_placeholder' | translate }}" #search
          (keyup)="searchUser($event)" (change)="searchUser($event)" />
      </div>
      <!--Search user result-->
      <div *ngIf="shareObject.searchUserList" class="search-result pt-2">
        <div *ngFor="let user of shareObject.searchUserList" class="user-item">
          <div class="d-flex align-items-center border-bottom" (click)="selectUser(user.id)" role="button">
            <div class="user-avatar">
              <img *ngIf="user.profile?.avatar" [src]="user.profile?.avatar" alt="{{ user.profile?.name }}"
                class="avatar" />
              <img *ngIf="!user.profile?.avatar" src="/assets/user.png" alt="{{ user.profile?.name }}" class="avatar" />
            </div>
            <div class="user-info">
              <div class="user-name fw-bold">{{ user.profile?.name }}</div>
              <div class="user-last-message fs-8">{{ user.profile?.phone }}</div>
            </div>
          </div>
        </div>
      </div>
      <!--Loading-->
      <div *ngIf="shareObject.searchTyping" class="loading d-flex justify-content-center align-items-center my-2">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!--List room-->
      <div *ngIf="!shareObject.searchUserList" class="chat-room-list">
        <div *ngFor="let room of shareObject.rooms"
          class="room-item {{room.id===shareObject?.room?.id ? 'active' : ''}} fs-7" (click)="selectRoom(room)">
          <div class="d-flex align-items-center" (click)="selectRoom(room)" role="button">
            <div class="user-avatar">
              <img *ngIf="room.data.avatar" [src]="room.data.avatar" alt="{{ room.data.name }}" class="avatar" />
              <img *ngIf="!room.data.avatar" src="/assets/user.png" alt="{{ room.data.name }}" class="avatar" />
            </div>
            <div class="user-info">
              <div class="user-name fw-bold limit-text">{{ room.data.name }}</div>
              <div class="user-last-message fs-8">{{ room.lastMessage?.content }}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="chat-box">
      <div *ngIf="shareObject.room">
        <div class="chat-header d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center gap-2 fs-7">
            <div class="room-avatar">
              <img *ngIf="shareObject.room.data.avatar" [src]="shareObject.room.data.avatar"
                alt="{{ shareObject.room.data.name }}" class="avatar" />
              <img *ngIf="!shareObject.room.data.avatar" src="/assets/user.png" alt="{{ shareObject.room.data.name }}"
                class="avatar" />
            </div>
            <div class="room-info d-flex justify-content-between">
              <div class="room-name fw-bold">{{ shareObject.room.data.name }}</div>
            </div>
          </div>
          <div class="me-2">
            <i class="bi bi-layout-text-sidebar" (click)="shareObject.showInfoChat = !shareObject.showInfoChat"></i>
          </div>
        </div>
      </div>
      <div class="chat-messages p-2" (scroll)="onScrollUp($event)" #messageContainer>
        <div *ngIf="shareObject.isMessageLoading" class="loading d-flex justify-content-center align-items-center my-2">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div *ngFor="let message of shareObject.messages" class="message-item w-100">
          <div *ngIf="message.user.id === sharedService.user.id" class="message message-receiver">
            <div class="message-content" [innerHTML]="message.content"></div>
            <div class="message-header">
              <span class="message-time">{{message.createdAt|date:'short'}}</span>
              <span class="sender-name">{{ message.user.profile.name }}</span>
            </div>
          </div>
          <div *ngIf="message.user.id !== sharedService.user.id" class="message message-sender">
            <div class="message-content" [innerHTML]="message.content"></div>
            <div class="message-header">
              <span class="sender-name">{{ message.user.profile.name }}</span>
              <span class="message-time">{{message.createdAt|date:'short'}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="chat-input d-flex justify-content-between align-items-center">
        <label for="file" role="button" class="px-3 fs-4"><i class="bi bi-paperclip"></i></label>
        <input type="file" id="file" hidden>
        <textarea type="text" class="form-control" #chatMessage
          placeholder="{{ 'type_message_placeholder' | translate }}"
          (keyup.enter)="sendMessage(chatMessage)"></textarea>
        <div class="px-3"><i class="bi bi-send-fill fs-4 text-primary" (click)="sendMessage(chatMessage)"></i></div>
        <!-- <button class="btn btn-primary" (click)="sendMessage(chatMessage)">{{ 'send' | translate }}</button> -->
      </div>
    </div>
    <!-- view info chat -->
    <div *ngIf="shareObject.showInfoChat && !shareObject.memberInfo" class="chat-info px-3 pt-2 border-start">
      <div class="d-flex justify-content-between align-items-center mb-2 border-bottom">
        <i class="bi bi-people fs-4"></i>
        <div class="text-uppercase">{{shareObject.room.participants.length}} {{'chat_member'|translate}}</div>
        <i class="bi bi-person-add fs-4" role="button" (click)="sharedService.modalControl('#add-member')"></i>
      </div>
      <div class="">
        <div *ngFor="let item of shareObject.room.participants" (click)="shareObject.memberInfo=item"
          class="d-flex align-items-center fs-7" role="button">
          <div class="room-avatar d-flex align-items-center me-0">
            <img *ngIf="shareObject.room.data.avatar" [src]="shareObject.room.data.avatar"
              alt="{{ shareObject.room.data.name }}" class="avatar" />
            <img *ngIf="!shareObject.room.data.avatar" src="/assets/user.png" alt="{{ shareObject.room.data.name }}"
              class="avatar" />
          </div>
          <div>
            <div>{{item.email}}</div>
            <div class="fs-8">{{item.profile?.phone}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- view member panel -->
    <div *ngIf="shareObject.memberInfo" class="chat-info px-3 pt-2">
      <div class="d-flex align-items-center gap-2 fs-7">
        <i class="bi bi-arrow-left" (click)="shareObject.memberInfo=undefined"></i>
        <div class="room-avatar">
          <img *ngIf="shareObject.room.data.avatar" [src]="shareObject.room.data.avatar"
            alt="{{ shareObject.memberInfo.profile.name }}" class="avatar" />
          <img *ngIf="!shareObject.room.data.avatar" src="/assets/user.png"
            alt="{{ shareObject.memberInfo.profile.name }}" class="avatar" />
        </div>
        <div class="room-info d-flex justify-content-between">
          <div class="room-name fw-bold">{{ shareObject.memberInfo.profile.name }}</div>
        </div>
      </div>
      <div class="">
        <div class="mb-3">{{shareObject.memberInfo.email }}</div>
        <div class="mb-3">
          <span>{{shareObject.memberInfo.profile.phone }}</span>
          <p class="form-text">{{'chat_member_mobile'|translate}}</p>
        </div>
        <div class="text-uppercase fs-7 fw-medium">
          <div role="button" class="text-primary fw-medium mb-2"
            (click)="selectUser(shareObject.memberInfo.id);shareObject.memberInfo=undefined;shareObject.showInfoChat=false">
            {{'chat_send_message'|translate}}
          </div>
          <div role="button" class="text-danger fw-medium mb-2"
            (click)="removeMember(shareObject.memberInfo.id);shareObject.memberInfo=undefined">
            {{'chat_remove_member'|translate}}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal modal-sm" id="add-member" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'title_chat_add_member'|translate}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <input type="text" class="form-control form-control-sm rounded-1"
          placeholder="{{ 'search_user_placeholder' | translate }}" (keyup)="searchUser($event)"
          (change)="searchUser($event)" />
        <div class="list-group mt-2 bg-light px-1">
          <div *ngFor="let user of shareObject.searchUserList"
            class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div>
                <div>{{ user.email }}</div>
              </div>
            </div>
            <input type="checkbox" (change)="selectMember(user.id)" class="form-check-input" />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm rounded-1 btn-secondary"
          data-bs-dismiss="modal">{{'btn_close'|translate}}</button>
        <button type="button" class="btn btn-sm rounded-1 btn-primary"
          (click)="addMember()">{{'btn_add'|translate}}</button>
      </div>
    </div>
  </div>
</div>